var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ReadonlyService } from './readonly.service';
var FormLabelComponent = /** @class */ (function (_super) {
    __extends(FormLabelComponent, _super);
    function FormLabelComponent(service, baseService, cdRef, rservice) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.rservice = rservice;
        _this.preWrap = true;
        return _this;
    }
    FormLabelComponent.prototype.ngOnInit = function () {
        var _this = this;
        // super.ngOnInit();
        this.refSubsc = this.service.refObservable.subscribe(function (flg) {
            if (flg) {
                _this.setValue();
                _this.cdRef.detectChanges();
            }
        });
    };
    FormLabelComponent.prototype.ngOnChanges = function (changes) {
        this.setValue();
    };
    FormLabelComponent.prototype.setValue = function () {
        this.label = this.rservice.getValue(this.componentName, this.col, this.val, 'label');
    };
    FormLabelComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.refSubsc) {
            this.refSubsc.unsubscribe();
        }
    };
    FormLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-formlabel',
                    template: '<label [class.formLabel]="key === \'list\' ? false : preWrap" [title]="col?.params?.ellipsis ? val : \'\'" [col]="col" [val]="val" formlabelDir>{{ label }}</label>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormLabelComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef },
        { type: ReadonlyService }
    ]; };
    FormLabelComponent.propDecorators = {
        preWrap: [{ type: Input }]
    };
    return FormLabelComponent;
}(ColumnBaseComponent));
export { FormLabelComponent };
//# sourceMappingURL=label.component.js.map